import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'filterBy'})
export class FilterByPipe implements PipeTransform {
  transform<T>(iterator: IterableIterator<T>, property: string, value: any): Array<T> {
    const collection = Array.from(iterator);
    if (!collection || !property || !value) {
      return null;
    }

    return collection.filter(obj => obj[property] == value);
  }
}
